/**
 * Powers the "slider" (superposed) layout rendered by
 * snippets/image-comparison.liquid.
 *
 * The native <input type="range"> in the markup is the actual control — it
 * provides pointer dragging, track clicks, touch and keyboard support without
 * custom gesture code. This element only mirrors the input's value into the
 * `--image-comparison-position` custom property; component-image-comparison.css
 * clips the second image and positions the decorative handle from that single
 * value. Without JS the divider stays at the 50% CSS default.
 */
if (!customElements.get('image-comparison')) {
  customElements.define(
    'image-comparison',
    class ImageComparison extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('input', this.onRangeInput);
      }

      onRangeInput(event) {
        if (!event.target.classList.contains('image-comparison__range')) return;
        this.style.setProperty('--image-comparison-position', `${event.target.value}%`);
      }
    }
  );
}
